<template>
  <div data-test="us-text-tags" class="us-text-tags button--label">
    <ul class="us-text-tags__list">
      <li
        v-for="(label, idx) in tags"
        :key="idx"
        class="us-text-tags__list-item"
      >
        {{ label }}
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'USTextTags',
  props: {
    tags: { type: Array as PropType<Array<string>>, required: true }
  }
})
</script>

<style lang="scss" scoped>
.us-text-tags {
  color: var(--color--primary-b1);
  margin: var(--spacing--8) 0;

  &__list {
    display: flex;
    flex-flow: row wrap;
  }

  &__list-item {
    &:not(:last-child) {
      &:after {
        content: '\25CF';
        margin: 0 var(--spacing--8);
      }
    }
  }
}
</style>
